// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"277e9dd1","483":"ea46d2d7","773":"3124abfa"}[chunkId] + ".chunk.js";
};